export default [
  [
    'Happiness',
    'Happiness is not something ready made. It comes from your own actions.',
    'Dalai Lama',
  ],
  [
    'The Journey Begins',
    'The journey of a thousand miles begins with a single step.',
    'Lao Tzu',
  ],
  [
    'Be the Change',
    'Be the change that you wish to see in the world.',
    'Mahatma Gandhi',
  ],
  [
    'Your Destiny',
    'The only person you are destined to become is the person you decide to be.',
    'Ralph Waldo Emerson',
  ],
  [
    "Don't Dwell on the Past",
    "Don't let yesterday take up too much of today.",
    'Will Rogers',
  ],
  [
    'Believe in Yourself',
    "Believe you can and you're halfway there.",
    'Theodore Roosevelt',
  ],
  [
    "Don't Give Up Your Power",
    "The most common way people give up their power is by thinking they don't have any.",
    'Alice Walker',
  ],
  [
    'The Power of the Mind',
    'The mind is everything. What you think you become.',
    'Buddha',
  ],
  [
    'Your Thoughts Create Your Reality',
    "Whether you think you can or you think you can't, you're right.",
    'Henry Ford',
  ],
  [
    'Just Get Started',
    'The secret of getting ahead is getting started.',
    'Mark Twain',
  ],
  [
    'Tie Your Life to a Goal',
    'If you want to live a happy life, tie it to a goal, not to people or things.',
    'Albert Einstein',
  ],
  [
    'Be the Change You Want to See',
    'You must be the change you wish to see in the world.',
    'Mahatma Gandhi',
  ],
  [
    'Do What You Love',
    'The only way to do great work is to love what you do.',
    'Steve Jobs',
  ],
  [
    'Success is a Journey',
    'Success is not final, failure is not fatal: it is the courage to continue that counts.',
    'Winston Churchill',
  ],
  [
    'Never Too Old to Dream',
    'You are never too old to set another goal or to dream a new dream.',
    'C.S. Lewis',
  ],
  [
    'Celebrate Your Life',
    'The more you praise and celebrate your life, the more there is in life to celebrate.',
    'Oprah Winfrey',
  ],
  [
    'Do Your Best',
    'Do what you can, with what you have, where you are.',
    'Theodore Roosevelt',
  ],
  [
    'Nothing is Impossible',
    "Nothing is impossible, the word itself says 'I'm possible'!",
    'Audrey Hepburn',
  ],
  [
    'Focus on the Seeds You Plant',
    "Don't judge each day by the harvest you reap but by the seeds that you plant.",
    'Robert Louis Stevenson',
  ],
  [
    'Be Better Than Yesterday',
    'The only person you need to be better than is the person you were yesterday.',
  ],
];
